import { connectHook } from 'app/common/components/connect-hook';
import { BranchMerge } from './branch-merge';
import { useBranchMerge } from './branch-merge-hook';

export default connectHook(BranchMerge, useBranchMerge);
